import { useFeatureGate } from '@statsig/react-bindings';
import { useAuthUser } from './useAuth';

export const useBatteryDateEnabled = () => {
  const { value: featureGate } = useFeatureGate('sensor_battery_change_date');
  const { roles } = useAuthUser();
  return (
    featureGate ||
    roles.includes('Superuser') ||
    roles.includes('StudioWeb') ||
    roles.includes('Installer')
  );
};
